import _0x4ef338 from'./addClasses.js';import _0x316d99 from'./removeClasses.js';export default{'addClasses':_0x4ef338,'removeClasses':_0x316d99};